import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RestApi } from '../RestApi/restApi';

interface summaryDashboardInfo {
  statusMessage: any,
  error: boolean,
  data: any
}

@Injectable({
  providedIn: 'root'
})
export class SummaryDashboardService {

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(
      private http: HttpClient,
      private snackBar: MatSnackBar,
      private spinner: NgxUiLoaderService,
      private restAPI: RestApi
    ) { }
  retreiveETLMigrationCount(filterDetails) {
    return this.http.post<summaryDashboardInfo>(this.restAPI.ETL_MIGRATION_COUNT_SUMMARY,JSON.stringify(filterDetails),{ headers: this.headers })
  }
  retreiveLoadObjectsCount(filterDetails) {
    return this.http.post<summaryDashboardInfo>(this.restAPI.LOAD_OBJECTS_COUNT_SUMMARY,JSON.stringify(filterDetails),{ headers: this.headers })
  }
  
}
